"use client";

import { FC } from "react";
import { PREPAID_BLOCK_NOTICE } from "../helpers/prepaidBlockExperiment";
import { usePrepaidCardsBlocked } from "../hooks/usePrepaidCardsBlocked";
import Typography from "./Typography";

// The block-prepaid arm's disclosure, shown above the plan cards so it comes
// before every "Get started" button at any width. Renders nothing for
// everyone else.
const PrepaidBlockNotice: FC<{ className?: string }> = ({ className }) => {
  const blocked = usePrepaidCardsBlocked();
  if (!blocked) return null;
  return (
    <Typography
      variant="caption"
      component="p"
      role="note"
      className={`${className ?? ""} text-slate-600 max-w-2xl mx-auto`}
      data-testid="prepaid-block-notice"
    >
      {PREPAID_BLOCK_NOTICE}
    </Typography>
  );
};

export default PrepaidBlockNotice;
